import React, { ButtonHTMLAttributes } from 'react';
import styled from 'astroturf/react';
import _Container from "Pill-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/design_system/Pill.tsx?styleId=Container";


export const Container = /*#__PURE__*/styled("button", null, {
  displayName: "Container",
  styles: _Container
});

export type PillProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  color?: 'primary' | 'gray';
  active?: boolean;
};

export const Pill: React.FC<PillProps> = ({
  color = 'primary',
  active = false,
  children,
  ...props
}) => {
  return (
    <Container color={color} active={active} {...props}>
      {children}
    </Container>
  );
};
